import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import useStyles from './styles';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Button, Paper, Typography } from '@mui/material';
import { BackdropLoader, toast, Icon, BasicTooltip } from '@livable/saas-react-components';
import { AddEditBillingTemplateModal } from './AddEditBillingTemplateModal';
import { UtilityCredentialStatusLine } from 'src/components/property/UtilityPortalCredentials/UtilityCredentialStatusLine';
import { findCredentialForUtility } from 'src/components/property/UtilityPortalCredentials/credentialStatus';
import { UrjanetLoginModal } from './UrjanetLoginModal';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { FileViewModal } from './FileViewModal';
import { ActivateAutoBillingModal } from './ActivateAutoBillingModal';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { CombineMultipleUtilitiesModal } from './CombineMultipleUtilitiesModal';
import { toJS } from 'mobx';
import { SimpleConfirmationModal } from 'src/components/shared/SimpleConfirmationModal';
import { singleElementOfArray } from 'src/utils/singleElementOfArray';
import { AutoBillingSimpleInfoModal } from './AutoBillingSimpleInfoModal';
import { BillingAutomationSetup } from './BullingAutomationSetup';
import { BigWarningAlert } from 'src/components/general/BigAlerts';
import DOMPurify from 'dompurify';
import { currentCompanyId } from 'src/components/property/UtilityPortalCredentials/currentCompanyId';
import { isLivableStaffFromToken } from 'src/components/property/UtilityPortalCredentials/isLivableStaffFromToken';
export const ProviderSetup = observer(_ref => {
  let propertyId = _ref.propertyId;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState('create'),
    _useState4 = _slicedToArray(_useState3, 2),
    billingAutomationSetupModalStatesDemo = _useState4[0],
    setBillingAutomationSetupModalStatesDemo = _useState4[1]; // NOTE: for demo purposes statuses - create | activate | activated
  const handleBillingAutomationSetupModalStatesDemo = state => {
    switch (state) {
      case 'activate':
        setBillingAutomationSetupModalStatesDemo(state);
        break;
      case 'activated':
        setBillingAutomationSetupModalStatesDemo(state);
        break;
      case 'create':
      default:
        setBillingAutomationSetupModalStatesDemo(state);
        break;
    }
  };
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    companyCredentials = _useState6[0],
    setCompanyCredentials = _useState6[1];
  // Utility portal credentials for THIS property, keyed to utility rows by propertyUtilityId.
  // Staff-only; a customer session never fetches them and would get 403 if it tried.
  const _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    portalCredentials = _useState8[0],
    setPortalCredentials = _useState8[1];
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    fetchTrigger = _useState0[0],
    setFetchTrigger = _useState0[1];
  const _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    propertyUtilitiesList = _useState10[0],
    setPropertyUtilitiesList = _useState10[1];
  const _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    buildingIds = _useState12[0],
    setBuildingIds = _useState12[1];
  const _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    removeTemplateModalState = _useState14[0],
    setRemoveTemplateModalState = _useState14[1];
  const _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    removeTemplateModalPassOver = _useState16[0],
    setRemoveTemplateModalPassOver = _useState16[1];
  const _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    removeTemplateModalBodyText = _useState18[0],
    setRemoveTemplateModalBodyText = _useState18[1];
  const deletePropertyUtility = _ref2 => {
    let propertyUtilityId = _ref2.propertyUtilityId,
      urjanetCredentialsForProvider = _ref2.urjanetCredentialsForProvider,
      utilityName = _ref2.utilityName,
      providerName = _ref2.providerName;
    setRemoveTemplateModalBodyText(null);
    setRemoveTemplateModalPassOver({
      propertyUtilityId,
      urjanetCredentialsForProvider
    });
    setRemoveTemplateModalBodyText("Do you want to delete ".concat(utilityName, " billing template for ").concat(providerName, "?"));
    setRemoveTemplateModalState(true);
  };
  const deletePropertyUtilitySubmitHandle = async _ref3 => {
    let propertyUtilityId = _ref3.propertyUtilityId,
      urjanetCredentialsForProvider = _ref3.urjanetCredentialsForProvider;
    setIsLoading(true);
    if (urjanetCredentialsForProvider !== null && !!(urjanetCredentialsForProvider !== null && urjanetCredentialsForProvider !== void 0 && urjanetCredentialsForProvider.id)) {
      const deleteCredentialsResp = await store.urjanet.deleteCredentialsAsync.run({
        id: urjanetCredentialsForProvider === null || urjanetCredentialsForProvider === void 0 ? void 0 : urjanetCredentialsForProvider.id
      });
      if (!deleteCredentialsResp.isSuccessful) {
        toast('error', {
          body: ['Credentials not deleted']
        });
        setIsLoading(false);
        setFetchTrigger(!fetchTrigger);
        setRemoveTemplateModalPassOver(null);
        return;
      }
    }
    const resp = await store.propertyUtility.deletePropertyUtilityAsync.run({
      propertyUtilityId
    });
    if (resp.isSuccessful) {
      toast('success', {
        body: ['Successfully deleted']
      });
    }
    setFetchTrigger(!fetchTrigger);
    setRemoveTemplateModalPassOver(null);
    setIsLoading(false);
  };
  const deletePropertyUtilityConfirmationActionHandler = _ref4 => {
    let action = _ref4.action,
      objectToPassOver = _ref4.objectToPassOver;
    if (action === 'submit') {
      deletePropertyUtilitySubmitHandle(objectToPassOver);
    }
    setRemoveTemplateModalState(false);
  };
  const callbackTrigger = () => {
    setFetchTrigger(!fetchTrigger);
  };
  const fetchData = async () => {
    setIsLoading(true);
    setCompanyCredentials([]);
    setPropertyUtilitiesList([]);
    const getPropertyUtilitiesByPropertyAsyncPromise = store.propertyUtility.getPropertyUtilitiesByPropertyAsync.run({
      propertyId: propertyId
    }).then(resp => {
      if (resp !== null && resp !== void 0 && resp.isSuccessful) {
        setPropertyUtilitiesList(resp.response);
      }
    }).then(async () => {
      store.addNewProperty.utilitiesSetupV2.resetStoreToInitValues();
      await store.properties.getPropertyUtilityProvidersV3Async.run({
        propertyId
      }).then(async getPropertyUtilityProvidersAsyncResp => {
        var _getPropertyUtilityPr;
        if (getPropertyUtilityProvidersAsyncResp !== null && getPropertyUtilityProvidersAsyncResp !== void 0 && getPropertyUtilityProvidersAsyncResp.isSuccessful && getPropertyUtilityProvidersAsyncResp !== null && getPropertyUtilityProvidersAsyncResp !== void 0 && (_getPropertyUtilityPr = getPropertyUtilityProvidersAsyncResp.response) !== null && _getPropertyUtilityPr !== void 0 && _getPropertyUtilityPr.length) {
          const UtProvidersIds = getPropertyUtilityProvidersAsyncResp.response.map(utProvider => utProvider.utilityProviderId);
          const getUtilityProvidersListDataAsyncRes = await store.utilityProviders.getUtilityProvidersListDataAsync.run({
            utilityProviderIds: UtProvidersIds
          });
          if (getUtilityProvidersListDataAsyncRes !== null && getUtilityProvidersListDataAsyncRes !== void 0 && getUtilityProvidersListDataAsyncRes.isSuccessful) {
            var _getUtilityProvidersL;
            if (getUtilityProvidersListDataAsyncRes !== null && getUtilityProvidersListDataAsyncRes !== void 0 && (_getUtilityProvidersL = getUtilityProvidersListDataAsyncRes.response) !== null && _getUtilityProvidersL !== void 0 && _getUtilityProvidersL.length) {
              getUtilityProvidersListDataAsyncRes === null || getUtilityProvidersListDataAsyncRes === void 0 || getUtilityProvidersListDataAsyncRes.response.forEach(utilityProvider => store.addNewProperty.utilitiesSetupV2.addProvider(utilityProvider, true));
              getPropertyUtilityProvidersAsyncResp === null || getPropertyUtilityProvidersAsyncResp === void 0 || getPropertyUtilityProvidersAsyncResp.response.map(utilityProvider => {
                const matchingProvider = getUtilityProvidersListDataAsyncRes.response.find(i => i.id === utilityProvider.utilityProviderId);
                const utilitiesToUpdate = !!propertyId && utilityProvider.utilities.map(utility => {
                  const matchUtility = matchingProvider.utilities.find(i => i.id === utility.utilityId);
                  utility.isCustom = matchUtility === null || matchUtility === void 0 ? void 0 : matchUtility.isCustom;
                  utility.utilityTypeId = matchUtility === null || matchUtility === void 0 ? void 0 : matchUtility.utilityTypeId;
                  return utility;
                });
                store.addNewProperty.utilitiesSetupV2.setUtilitiesInfoAfterLoad([_objectSpread(_objectSpread({}, matchingProvider), {}, {
                  utilities: utilitiesToUpdate
                })], false);
              });
            }
          }
        }
      });
    });
    const getCompanyCredentialsAsyncPromise = store.urjanet.getCompanyCredentialsAsync.run({}).then(respCreds => {
      if (respCreds !== null && respCreds !== void 0 && respCreds.isSuccessful) {
        setCompanyCredentials(respCreds.response);
      }
    });

    // Portal credentials are additive to this page: a failure here must leave the utility list fully
    // usable, so it resolves rather than rejects and never joins the Promise.all failure path.
    const getPortalCredentialsPromise = store.account.userProfile.isUserLivableStaff ? store.admin.getUtilityCredentialsAsync.run({
      companyId: currentCompanyId(),
      propertyId
    }).then(resp => {
      var _filter, _ref5;
      return setPortalCredentials(((_filter = (_ref5 = (resp === null || resp === void 0 ? void 0 : resp.response) || resp || []).filter) === null || _filter === void 0 ? void 0 : _filter.call(_ref5, Boolean)) || []);
    }).catch(() => setPortalCredentials([])) : Promise.resolve();
    const getBuildingAsyncPromise = store.buildings.getBuildingAsync.run({
      propertyId
    }).then(buildingsResp => {
      if (buildingsResp.isSuccessful) setBuildingIds(buildingsResp.response.map(item => item.id));
    });
    await Promise.all([getPropertyUtilitiesByPropertyAsyncPromise, getCompanyCredentialsAsyncPromise, getPortalCredentialsPromise, getBuildingAsyncPromise]);
    setIsLoading(false);
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchTrigger]);
  const PropertyUtilityListItem = _ref6 => {
    var _propertyUtility$prov2;
    let provider = _ref6.provider,
      propertyUtility = _ref6.propertyUtility;
    const urjanetCredentialsForProvider = companyCredentials.find(credential => {
      var _propertyUtility$prov;
      return credential.livableProviderId === (propertyUtility === null || propertyUtility === void 0 || (_propertyUtility$prov = propertyUtility.provider) === null || _propertyUtility$prov === void 0 ? void 0 : _propertyUtility$prov.utilityProviderId) && (credential === null || credential === void 0 ? void 0 : credential.propertyId) === propertyId;
    }) || null;
    if ((_propertyUtility$prov2 = propertyUtility.provider) !== null && _propertyUtility$prov2 !== void 0 && _propertyUtility$prov2.isAppAutomationEnabled && urjanetCredentialsForProvider === null) {
      return /*#__PURE__*/React.createElement("div", {
        className: classes.listItem
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeader
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderData
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderDataTitle
      }, propertyUtility.utilityTypes.map(i => i.utilityTypeName).join('/') || 'N/a'), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderDataCaption
      }, propertyUtility.provider.utilityProviderName), /*#__PURE__*/React.createElement(UtilityCredentialStatusLine, {
        credential: findCredentialForUtility(portalCredentials, propertyUtility.propertyUtilityId),
        isVisible: isLivableStaffFromToken()
      })), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderActions
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderActionsItem
      }, /*#__PURE__*/React.createElement(BillingAutomationSetup, {
        handleModalStates: handleBillingAutomationSetupModalStatesDemo,
        customTrigger: /*#__PURE__*/React.createElement(BasicTooltip, {
          title: t('Billing automation'),
          placement: "top"
        }, /*#__PURE__*/React.createElement(Button, {
          variant: "actionIcon",
          size: "large",
          className: "".concat(classes.autoBillingTrigger, " ").concat(billingAutomationSetupModalStatesDemo === 'activated' && 'activated' || billingAutomationSetupModalStatesDemo === 'error' && 'error' || ''),
          'custom-attribute': '171-provider-setup'
        }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
          type: "paper-dollar"
        })), t('add_new_property_flow.auto_billing_status_label_btn'), ' ', /*#__PURE__*/React.createElement(Typography, {
          variant: "h5",
          component: "p"
        }, billingAutomationSetupModalStatesDemo === 'activated' ? 'Active' : 'Inactive'))),
        isEdit: billingAutomationSetupModalStatesDemo === 'activated'
      })), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderActionsItem
      }, /*#__PURE__*/React.createElement(AddEditBillingTemplateModal, {
        companyCredentials: companyCredentials,
        propertyId: propertyId,
        currentBuildingId: singleElementOfArray(buildingIds),
        existingPropertyProviders: toJS(store.addNewProperty.utilitiesSetupV2.getUtilityProviders),
        propertyUtility: propertyUtility,
        isCredentialsUpdate: false,
        isEditBillingTemplate: true,
        callbackTrigger: callbackTrigger,
        customTrigger: /*#__PURE__*/React.createElement(BasicTooltip, {
          title: t('add_new_property_flow.edit_billing_template'),
          placement: "top"
        }, /*#__PURE__*/React.createElement(Button, {
          variant: "actionIcon",
          size: "large",
          'custom-attribute': '172-provider-setup'
        }, /*#__PURE__*/React.createElement(Icon, {
          type: "edit"
        })))
      })), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderActionsItem
      }, /*#__PURE__*/React.createElement(BasicTooltip, {
        title: t('add_new_property_flow.remove_billing_template'),
        placement: "top"
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "actionIcon",
        size: "large",
        onClick: event => deletePropertyUtility({
          event,
          propertyUtilityId: propertyUtility.propertyUtilityId,
          urjanetCredentialsForProvider,
          utilityName: propertyUtility.utilityTypes.map(i => i.utilityTypeName).join('/'),
          providerName: propertyUtility.provider.utilityProviderName
        }),
        'custom-attribute': '173-provider-setup'
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "trash"
      })))))), /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.listItemBody, " newAutoBilling")
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemBodyContent
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemBodyIcon
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "paper-dollar"
      })), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemBodyDetails
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.listItemBodyDetailsTitle, " newAutoBillingDetailText")
      }, t('add_new_property_flow.auto_billing_is_available_activate')), /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.listItemBodyDetailsCaption, " newAutoBillingDetailText")
      }, /*#__PURE__*/React.createElement("div", null, t('add_new_property_flow.login_into_you_urjanet_account', {
        providerName: propertyUtility.provider.utilityProviderName
      })))), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemBodyActions
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemBodyAction
      }, /*#__PURE__*/React.createElement(UrjanetLoginModal, {
        companyCredentials: companyCredentials,
        propertyId: propertyId,
        providerInfo: provider,
        propertyUtility: propertyUtility,
        callbackTrigger: callbackTrigger,
        customTrigger: /*#__PURE__*/React.createElement(Button, {
          variant: "text",
          size: "small",
          'custom-attribute': '174-provider-setup'
        }, t('add_new_property_flow.begin_activation'))
      }))))));
    } else if (propertyUtility.provider.isAppAutomationEnabled && urjanetCredentialsForProvider !== null && (urjanetCredentialsForProvider.status === 'Pending' || urjanetCredentialsForProvider.status === 'Failed')) {
      return /*#__PURE__*/React.createElement("div", {
        className: classes.listItem
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeader
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderData
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderDataTitle
      }, propertyUtility.utilityTypes.map(i => i.utilityTypeName).join('/') || 'N/a'), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderDataCaption
      }, propertyUtility.provider.utilityProviderName), /*#__PURE__*/React.createElement(UtilityCredentialStatusLine, {
        credential: findCredentialForUtility(portalCredentials, propertyUtility.propertyUtilityId),
        isVisible: isLivableStaffFromToken()
      })), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderActions
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderActionsItem
      }, /*#__PURE__*/React.createElement(AddEditBillingTemplateModal, {
        key: 'EditBillingTemplateModalKEY_' + propertyUtility.propertyUtilityId,
        id: 'EditBillingTemplateModalID_' + propertyUtility.propertyUtilityId,
        companyCredentials: companyCredentials,
        propertyId: propertyId,
        currentBuildingId: singleElementOfArray(buildingIds),
        existingPropertyProviders: toJS(store.addNewProperty.utilitiesSetupV2.getUtilityProviders),
        propertyUtility: propertyUtility,
        isCredentialsUpdate: false,
        isEditBillingTemplate: true,
        callbackTrigger: callbackTrigger,
        customTrigger: /*#__PURE__*/React.createElement(BasicTooltip, {
          title: t('add_new_property_flow.edit_billing_template'),
          placement: "top"
        }, /*#__PURE__*/React.createElement(Button, {
          variant: "actionIcon",
          size: "large",
          'custom-attribute': '175-provider-setup'
        }, /*#__PURE__*/React.createElement(Icon, {
          type: "edit"
        })))
      })), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderActionsItem
      }, /*#__PURE__*/React.createElement(BasicTooltip, {
        title: t('add_new_property_flow.remove_billing_template'),
        placement: "top"
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "actionIcon",
        size: "large",
        onClick: event => deletePropertyUtility({
          event,
          propertyUtilityId: propertyUtility.propertyUtilityId,
          urjanetCredentialsForProvider,
          utilityName: propertyUtility.utilityTypes.map(i => i.utilityTypeName).join('/'),
          providerName: propertyUtility.provider.utilityProviderName
        }),
        'custom-attribute': '176-provider-setup'
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "trash"
      })))))), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemBody
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemBodyContent
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.listItemBodyIcon, " ").concat(urjanetCredentialsForProvider.status === 'Failed' ? 'error' : '')
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "paper-dollar"
      })), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemBodyDetails
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemBodyDetailsTitle
      }, t('add_new_property_flow.auto_billing')), urjanetCredentialsForProvider.status === 'Pending' && /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.listItemBodyDetailsCaption, " loading")
      }, t('add_new_property_flow.login_in'), /*#__PURE__*/React.createElement("span", null, "."), /*#__PURE__*/React.createElement("span", null, "."), /*#__PURE__*/React.createElement("span", null, ".")), urjanetCredentialsForProvider.status === 'Failed' && /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.listItemBodyDetailsCaption, " ").concat(urjanetCredentialsForProvider.status === 'Failed' ? 'error' : '')
      }, t('add_new_property_flow.login_failed'))), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemBodyActions
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemBodyAction
      }, /*#__PURE__*/React.createElement(UrjanetLoginModal, {
        companyCredentials: companyCredentials,
        propertyId: propertyId,
        providerInfo: provider,
        propertyUtility: propertyUtility,
        callbackTrigger: callbackTrigger,
        isEdit: true,
        customTrigger: /*#__PURE__*/React.createElement(Button, {
          variant: "text",
          size: "small",
          'custom-attribute': '177-provider-setup'
        }, t('add_new_property_flow.use_different_creds'))
      })), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemBodyAction
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        size: "small",
        disabled: true,
        'custom-attribute': '178-provider-setup'
      }, t('add_new_property_flow.finish_activation')))))));
    } else if (propertyUtility.provider.isAppAutomationEnabled && urjanetCredentialsForProvider !== null && urjanetCredentialsForProvider.status === 'Completed' && (urjanetCredentialsForProvider === null || urjanetCredentialsForProvider === void 0 ? void 0 : urjanetCredentialsForProvider.accounts.findIndex(i => propertyUtility.propertyUtilityId === (i === null || i === void 0 ? void 0 : i.livablePropertyUtilityId))) === -1) {
      var _urjanetCredentialsFo;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.listItem
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeader
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderData
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderDataTitle
      }, propertyUtility.utilityTypes.map(i => i.utilityTypeName).join('/') || 'N/a'), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderDataCaption
      }, propertyUtility.provider.utilityProviderName), /*#__PURE__*/React.createElement(UtilityCredentialStatusLine, {
        credential: findCredentialForUtility(portalCredentials, propertyUtility.propertyUtilityId),
        isVisible: isLivableStaffFromToken()
      })), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderActions
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.listItemHeaderActionsItem)
      }, /*#__PURE__*/React.createElement(BasicTooltip, {
        title: t('add_new_property_flow.auto_billing_inactive'),
        placement: "top"
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "actionIcon",
        size: "large",
        'custom-attribute': '179-provider-setup'
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "paper-dollar"
      })))), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderActionsItem
      }, /*#__PURE__*/React.createElement(BasicTooltip, {
        title: t('add_new_property_flow.edit_billing_template'),
        placement: "top"
      }, /*#__PURE__*/React.createElement(AddEditBillingTemplateModal, {
        companyCredentials: urjanetCredentialsForProvider,
        propertyId: propertyId,
        currentBuildingId: singleElementOfArray(buildingIds),
        existingPropertyProviders: toJS(store.addNewProperty.utilitiesSetupV2.getUtilityProviders),
        propertyUtility: propertyUtility,
        isCredentialsUpdate: false,
        isEditBillingTemplate: true,
        callbackTrigger: callbackTrigger,
        customTrigger: /*#__PURE__*/React.createElement(BasicTooltip, {
          title: t('add_new_property_flow.edit_billing_template'),
          placement: "top"
        }, /*#__PURE__*/React.createElement(Button, {
          variant: "actionIcon",
          size: "large",
          'custom-attribute': '180-provider-setup'
        }, /*#__PURE__*/React.createElement(Icon, {
          type: "edit"
        })))
      }))), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderActionsItem
      }, /*#__PURE__*/React.createElement(BasicTooltip, {
        title: t('add_new_property_flow.remove_billing_template'),
        placement: "top"
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "actionIcon",
        size: "large",
        onClick: event => deletePropertyUtility({
          event,
          propertyUtilityId: propertyUtility.propertyUtilityId,
          urjanetCredentialsForProvider,
          utilityName: propertyUtility.utilityTypes.map(i => i.utilityTypeName).join('/'),
          providerName: propertyUtility.provider.utilityProviderName
        }),
        'custom-attribute': '181-provider-setup'
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "trash"
      })))))), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemBody
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemBodyContent
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemBodyIcon
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "paper-dollar"
      })), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemBodyDetails
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemBodyDetailsTitle
      }, t('add_new_property_flow.auto_billing')), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemBodyDetailsCaption
      }, t('add_new_property_flow.you_logged_it_as', {
        accountNumber: (urjanetCredentialsForProvider === null || urjanetCredentialsForProvider === void 0 || (_urjanetCredentialsFo = urjanetCredentialsForProvider.accounts[0]) === null || _urjanetCredentialsFo === void 0 ? void 0 : _urjanetCredentialsFo.normalizedAccountNumber) || 'pending account number'
      }))), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemBodyActions
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemBodyAction
      }, /*#__PURE__*/React.createElement(UrjanetLoginModal, {
        companyCredentials: companyCredentials,
        propertyId: propertyId,
        providerInfo: provider,
        propertyUtility: propertyUtility,
        callbackTrigger: callbackTrigger,
        isEdit: true,
        customTrigger: /*#__PURE__*/React.createElement(Button, {
          variant: "text",
          size: "small",
          'custom-attribute': '182-provider-setup'
        }, t('add_new_property_flow.use_different_creds'))
      })), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemBodyAction
      }, /*#__PURE__*/React.createElement(ActivateAutoBillingModal, {
        key: 'ActivateAutoBillingModalKEY_' + propertyUtility.propertyUtilityId,
        id: 'ActivateAutoBillingModalID_' + propertyUtility.propertyUtilityId,
        companyCredentials: companyCredentials,
        urjanetCredentialsForProvider: urjanetCredentialsForProvider,
        propertyId: propertyId,
        providerInfo: provider,
        propertyUtility: propertyUtility,
        callbackTrigger: callbackTrigger,
        customTrigger: /*#__PURE__*/React.createElement(Button, {
          variant: "contained",
          size: "small",
          'custom-attribute': '183-provider-setup'
        }, t('add_new_property_flow.finish_activation'))
      }))))));
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: classes.listItem
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeader
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderData
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderDataTitle
      }, propertyUtility.utilityTypes
      // .filter(i => !!i.isEnabled)
      .map(i => i.utilityTypeName).join('/') || 'N/a'), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderDataCaption
      }, propertyUtility.provider.utilityProviderName), /*#__PURE__*/React.createElement(UtilityCredentialStatusLine, {
        credential: findCredentialForUtility(portalCredentials, propertyUtility.propertyUtilityId),
        isVisible: isLivableStaffFromToken()
      })), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderActions
      }, propertyUtility.provider.isAppAutomationEnabled && urjanetCredentialsForProvider !== null && urjanetCredentialsForProvider.status === 'Completed' && (urjanetCredentialsForProvider === null || urjanetCredentialsForProvider === void 0 ? void 0 : urjanetCredentialsForProvider.accounts.find(i => propertyUtility.propertyUtilityId === (i === null || i === void 0 ? void 0 : i.livablePropertyUtilityId))) && /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.listItemHeaderActionsItem, " status")
      }, /*#__PURE__*/React.createElement(AutoBillingSimpleInfoModal, {
        iconType: 'success',
        titleText: t('add_new_property_flow.auto_billing_is_setup'),
        bodyText: t('add_new_property_flow.auto_billing_is_setup_description', {
          providerName: propertyUtility.provider.utilityProviderName
        }),
        customTrigger: /*#__PURE__*/React.createElement(BasicTooltip, {
          title: t('add_new_property_flow.auto_billing_enabled'),
          placement: "top"
        }, /*#__PURE__*/React.createElement(Button, {
          variant: "actionIcon",
          size: "large",
          'custom-attribute': '184-provider-setup'
        }, /*#__PURE__*/React.createElement(Icon, {
          type: "paper-dollar"
        })))
      })), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderActionsItem
      }, /*#__PURE__*/React.createElement(BasicTooltip, {
        title: t('add_new_property_flow.edit_billing_template'),
        placement: "top"
      }, /*#__PURE__*/React.createElement(AddEditBillingTemplateModal, {
        companyCredentials: companyCredentials,
        propertyId: propertyId,
        currentBuildingId: singleElementOfArray(buildingIds),
        existingPropertyProviders: toJS(store.addNewProperty.utilitiesSetupV2.getUtilityProviders),
        propertyUtility: propertyUtility,
        isCredentialsUpdate: false,
        isEditBillingTemplate: true,
        callbackTrigger: callbackTrigger,
        customTrigger: /*#__PURE__*/React.createElement(BasicTooltip, {
          title: t('add_new_property_flow.edit_billing_template'),
          placement: "top"
        }, /*#__PURE__*/React.createElement(Button, {
          variant: "actionIcon",
          size: "large",
          'custom-attribute': '185-provider-setup'
        }, /*#__PURE__*/React.createElement(Icon, {
          type: "edit"
        })))
      }))), /*#__PURE__*/React.createElement("div", {
        className: classes.listItemHeaderActionsItem
      }, /*#__PURE__*/React.createElement(BasicTooltip, {
        title: t('add_new_property_flow.remove_billing_template'),
        placement: "top"
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "actionIcon",
        size: "large",
        onClick: event => deletePropertyUtility({
          event,
          propertyUtilityId: propertyUtility.propertyUtilityId,
          urjanetCredentialsForProvider,
          utilityName: propertyUtility.utilityTypes.map(i => i.utilityTypeName).join('/'),
          providerName: propertyUtility.provider.utilityProviderName
        }),
        'custom-attribute': '186-provider-setup'
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "trash"
      })))))));
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper"
  }, store.company.companyFeatureStore.isAppfolio && !store.addNewProperty.utilitiesSetupV2.globalGlAccountExternalId && /*#__PURE__*/React.createElement("div", {
    className: classes.glLoader
  }, "Please select Default GL account first"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    className: classes.title
  }, t('add_new_property_flow.provider_setup')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, t('add_new_property_flow.provider_setup_caption')), /*#__PURE__*/React.createElement("div", {
    className: classes.addBillingTemplate
  }, /*#__PURE__*/React.createElement(AddEditBillingTemplateModal, {
    key: 'AddEditBillingTemplateModalKEY_NEW',
    id: 'AddEditBillingTemplateModalID_NEW',
    companyCredentials: companyCredentials,
    propertyId: propertyId,
    currentBuildingId: singleElementOfArray(buildingIds),
    callbackTrigger: callbackTrigger,
    existingPropertyProviders: toJS(store.addNewProperty.utilitiesSetupV2.getUtilityProviders)
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.list
  }, propertyUtilitiesList === null || propertyUtilitiesList === void 0 ? void 0 : propertyUtilitiesList.map((propertyUtility, index) => /*#__PURE__*/React.createElement(PropertyUtilityListItem, {
    key: index,
    propertyUtility: propertyUtility
  }))), /*#__PURE__*/React.createElement(SimpleConfirmationModal, {
    headerText: 'Billing template removal confirmation',
    bodyText: removeTemplateModalBodyText,
    externalIsOpen: removeTemplateModalState,
    callBack: deletePropertyUtilityConfirmationActionHandler,
    objectToPassOver: removeTemplateModalPassOver,
    customTrigger: null
  }), /*#__PURE__*/React.createElement(SimpleConfirmationModal, {
    key: 'Billing-Automation-Setup-Confirmation',
    headerText: t('add_new_property_flow.auto_billing_activation_modal_title'),
    bodyComponent: /*#__PURE__*/React.createElement(BigWarningAlert, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, t('add_new_property_flow.auto_billing_activation_modal_alert_title')), /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      dangerouslySetInnerHTML: {
        __html: DOMPurify.sanitize(t('add_new_property_flow.auto_billing_activation_modal_alert_content'))
      }
    })),
    externalIsOpen: billingAutomationSetupModalStatesDemo === 'activate',
    callBack: _ref7 => {
      let action = _ref7.action,
        objectToPassOver = _ref7.objectToPassOver;
      console.log('Billing-Automation-Setup-Confirmation', {
        action,
        objectToPassOver
      });
      if (action === 'cancel') {
        setBillingAutomationSetupModalStatesDemo('create');
      }
      if (action === 'submit') {
        setBillingAutomationSetupModalStatesDemo('activated');
      }
    },
    objectToPassOver: {
      test: 'Test value'
    },
    customTrigger: null
  }), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  })));
});